import { WorkspaceObjectsSettingsEditRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/objects/edit/$objectType')({
  component: WorkspaceObjectsSettingsEditRoute,
});
